import { useCallback, useMemo } from 'react';
import { Badge, Modal, Spacer, Text } from '@Sage/hoi-poi-ui';

import AutomationsHelpActions from 'components/AutomationsHelpActions';
import AutomationsTemplates from 'containers/settings/AutomationSettings/AutomationsTemplates';
import { getLiteral } from 'utils/getLiteral';
import { ensureRoute } from 'utils/routes';
import { logEvent } from 'utils/tracking';

const AutomationTemplatesModal = ({ entity, isOpen, onClose, openBuilder }) => {
    const classes = useMemo(
        () => ({
            content: 'fm-automation-entity-menu__content',
        }),
        [],
    );

    const modalTitle = useMemo(
        () => (
            <span className="fm-automation-entity-menu__title">
                <Text bold type="body">
                    {getLiteral('label_automations')}
                </Text>
                <Badge medium type="promotion">
                    {getLiteral('label_sidebar_new')}
                </Badge>
            </span>
        ),
        [],
    );

    const onConfirm = useCallback(() => {
        ensureRoute('/settings/automations/templates');
        logEvent({
            event: entity?.trueName || 'settings',
            submodule: 'automationsTemplate',
            functionality: 'seeAll',
        });
    }, [entity?.trueName]);

    const handleOpenBuilder = useCallback(
        (...args) => {
            onClose();
            openBuilder(...args);
        },
        [onClose, openBuilder],
    );

    return (
        <Modal
            cancelText={getLiteral('action_cancel')}
            classes={classes}
            confirmText={getLiteral('action_automations_see_all_templates')}
            headerComponent={
                <AutomationsHelpActions
                    className="fm-automation-entity-menu__header-actions"
                    knowledgeMoreUrl={getLiteral('label_automations_knowledge_base_link')}
                    trackingEvent={entity?.trueName}
                    videoTutorialLabel={getLiteral('action_automations_video_tutorial')}
                    videoTutorialUrl={getLiteral('label_automations_video_tutorial_link')}
                />
            }
            isOpen={isOpen}
            onCancel={onClose}
            onConfirm={onConfirm}
            onRequestClose={onClose}
            size="full"
            title={modalTitle}
            useHeader
        >
            <Text>{getLiteral('label_automations_desc')}</Text>
            <Spacer y={3} />
            <AutomationsTemplates
                defaultEntity={entity?.trueName}
                openBuilder={handleOpenBuilder}
            />
        </Modal>
    );
};

export default AutomationTemplatesModal;
